import { Typography } from "@povio/ui";
import { Fragment } from "react";

import ProfileSectionRow from "@/components/home/sections/components/ProfileSectionRow";
import ProfileWorkExperienceItem from "@/components/home/sections/components/ProfileWorkExperienceItem";
import type { ISectionProps } from "@/components/home/sections/ProfileBioSection";
import ProfileSectionCard from "@/components/home/sections/ProfileSectionCard";
import { ItemSectionDivider } from "@/components/ui/ItemSectionDivider";
import type { CommonModels } from "@/data/common/common.models";
import { DateUtils } from "@/util/date.utils";

interface IProps extends ISectionProps {
  certifications?: CommonModels.LicenseOrCertificationDto[];
}

const ProfileCertificationsSection = ({
  certifications,
  onEditSectionClicked,
  isPublic = false,
  enableInViewAnimation,
}: IProps) => {
  const filteredCertifications = certifications?.filter((item) => {
    return Object.values(item).some((value) => {
      if (value === null || value === undefined) return false;
      if (typeof value === "string") return value.trim() !== "";
      return true;
    });
  });

  return (
    <ProfileSectionCard
      title="Certifications and Rewards"
      isEmpty={!filteredCertifications || filteredCertifications.length === 0}
      onEditSectionClicked={onEditSectionClicked}
      isPublic={isPublic}
      enableInViewAnimation={enableInViewAnimation}
    >
      <div className="mt-6 flex flex-col gap-6">
        {filteredCertifications?.map((item, index) => (
          <Fragment key={index}>
            <ProfileSectionRow
              title={item.name}
              subTitle={
                <Typography
                  size="label-4"
                  className="text-text-default-3"
                >
                  {item.issue_date && DateUtils.getLocalizedDate(item.issue_date, "MMM yyyy")}
                </Typography>
              }
              index={index}
              sectionId="certifications"
              hasAdditionalInfo={!!item.issuing_organization || !!item.verification_url}
            >
              <ProfileWorkExperienceItem
                value={item.issuing_organization}
                segment="Issuing Organization"
              />
              <ProfileWorkExperienceItem
                value={item.verification_url}
                segment="Verification URL"
                isLink
              />
            </ProfileSectionRow>
            {index !== filteredCertifications.length - 1 && <ItemSectionDivider />}
          </Fragment>
        ))}
      </div>
    </ProfileSectionCard>
  );
};

export default ProfileCertificationsSection;
